<svelte:options accessors/>
<script>
    import Chart from 'chart.js/auto';
    import {onMount} from 'svelte';
    import NauiFilters from "../../naui/components/NauiFilters.svelte";

    export let data;
    export let filters;

    let filtersCmpt;
    let canvasCumplimento;
    let canvasVentas;

    let canvasPieEstado;
    let canvasPieSeguimiento;

    onMount(() => {
        const dataCumplimento = {
            labels: ['Diana Luis', 'Paula Guio', 'Carlos Mejía', 'Francisco Riveros', 'Diego Tobon', 'David Rey'],
            datasets: [{
                label: 'Ventas por responsable',
                data: [76, 66, 60, 51, 46, 45],
                backgroundColor: 'rgb(73, 88, 103)',
                borderColor: 'rgb(73, 88, 103)',
                borderWidth: 1,
                barThickness: 25
            }]
        };
        const dataVentas = {
            labels: [
                'No interesado',
                'Competencia',
                'Autosolución',
                'Disponibilidad',
                'Ubicación',
                'Precio',
                'No contesta',
                'No contesta',
                'Tamaño',
                'Oct',
                'Reporte'
            ],
            datasets: [{
                label: 'Razones por las que desiste',
                data: [165, 109, 100, 71, 56, 55, 48, 45, 43, 20, 11],
                backgroundColor: 'rgb(73, 88, 103)',
                borderColor: 'rgb(73, 88, 103)',
                borderWidth: 1,
                barThickness: 25
            }]
        };
        const pieDataEstado = {
            labels: ['Cliente inválido', 'Completado', 'Desiste', 'En seguimiento', 'Sin seguimiento'],
            datasets: [{
                label: 'Ocupación',
                data: [80, 21, 12, 9, 0],
                backgroundColor: [
                    'rgb(74,88,103)',
                    'rgb(201,217,207)',
                    'rgb(69,12,12)',
                    'rgb(215,234,109)',
                    'rgb(34, 213, 23)',
                    'rgb(14, 113, 53)',
                    'rgb(114, 13, 203)',
                ],
                borderWidth: 1
            }]
        }
        const pieDataSeguimiento = {
            labels: ['Caliente', 'Próximo mes', 'Frío'],
            datasets: [{
                label: 'Ocupación',
                data: [80, 21, 9],
                backgroundColor: [
                    'rgb(74,88,103)',
                    'rgb(201,217,207)',
                    'rgb(69,12,12)',
                    'rgb(215,234,109)',
                    'rgb(34, 213, 23)',
                    'rgb(14, 113, 53)',
                    'rgb(114, 13, 203)',
                ],
                borderWidth: 1
            }]
        }

        const pieOptions = {
            responsive: false,
            plugins: {
                legend: {
                    position: 'right'
                }
            }
        };
        const configPieBodegas = {type: 'pie', data: pieDataEstado, options: pieOptions};
        const configPieMetros = {type: 'pie', data: pieDataSeguimiento, options: pieOptions};

        new Chart(canvasPieEstado, configPieBodegas);
        new Chart(canvasPieSeguimiento, configPieMetros);

        new Chart(canvasCumplimento, getBarConfig(dataCumplimento));
        new Chart(canvasVentas, getBarConfig(dataVentas));
    });

    function getBarConfig(data) {
        return {
            type: 'bar',
            data: data,
            options: {
                indexAxis: 'y',
                scales: {
                    x: {
                        beginAtZero: true
                    }
                }
            },
        };
    }
</script>

<div class="py-15">
    <NauiFilters bind:this={filtersCmpt} {filters} on:filtered/>
</div>

<div class="mx-1 mb-1 max-w-500px">
    <table class="naui-table w-100">
        <tbody>
        <tr>
            <td>
                <div>VENTAS</div>
            </td>
            <td>
                <div><sub>Total mes</sub> {data.ventas.mes}</div>
            </td>
            <td>
                <div><sub>Mes anterior</sub> {data.ventas.anterior}</div>
            </td>
            <td>
                <div><sub>Diferencia</sub> {data.ventas.mes - data.ventas.anterior}</div>
            </td>
        </tr>
        </tbody>
    </table>
</div>

<div class="grid-2 gap-1">
    <div class="p-15 shadow radius 2">
        <h2 class="text-l mb-1">Cumplimento</h2>
        <canvas bind:this={canvasCumplimento} width="600" height="350"></canvas>
    </div>
    <div class="p-15 shadow radius 2">
        <h2 class="text-l mb-1">Estado</h2>
        <canvas bind:this={canvasPieEstado} width="600" height="300"></canvas>
    </div>
</div>

<div class="grid-2 gap-1 pt-1">
    <div class="p-15 shadow radius 2">
        <h2 class="text-l mb-1">Ventas</h2>
        <canvas bind:this={canvasVentas} width="600" height="500"></canvas>
    </div>
    <div class="p-15 shadow radius 2">
        <h2 class="text-l mb-1">Seguimiento</h2>
        <canvas bind:this={canvasPieSeguimiento} width="600" height="300"></canvas>
    </div>
</div>

